import { PxdAgGridForecastValidationCellRendererComponent } from '@app/shared/aggrid/pxd-ag-grid-forecast-validation-cell-renderer';
import { PxdAgGridColumnTypes, PxdAgGridDefaultColumnDef, PxdAgGridExcelStyles, PxdAgGridSideBarOptions, PxdAgGridStatusBarOptions, PXDDefaultExcelExportParams } from '@app/shared/aggrid/pxd-ag-grid-options';
import { GridOptions } from 'ag-grid-community';
import moment from 'moment';

export const capitalByWellGridOptions: GridOptions = {
  enableCharts: true,
  cellSelection: true,
  rowGroupPanelShow: 'never',
  defaultColDef: PxdAgGridDefaultColumnDef,
  statusBar: PxdAgGridStatusBarOptions,
  sideBar: PxdAgGridSideBarOptions,
  columnTypes: PxdAgGridColumnTypes,
  processCellForClipboard: function (params) {
    if (params && params.column && params.column.getColDef()) {
      const colDef = params.column.getColDef();
      if (colDef.type && colDef.type.includes('dateColumn') && params.value) {
        return moment(params.value).format('L');
      }
    }
    return params.value;
  },
  defaultExcelExportParams: PXDDefaultExcelExportParams,
  columnDefs: [
    { field: 'Ssn' },
    { field: 'WellName' },
    { field: 'Division' },
    { field: 'ForecastedWorkingInterest', hide: true },
    { field: 'SnapshotWorkingInterest' },
    { field: 'SpudDate', type: ['dateColumn'], cellClass: 'ExcelDate' },
    { field: 'RigReleaseDate', type: ['dateColumn'], cellClass: 'ExcelDate' },
    { field: 'FracStart', type: ['dateColumn'], cellClass: 'ExcelDate' },
    { field: 'FracEnd', type: ['dateColumn'], cellClass: 'ExcelDate' },
    { field: 'PopDate', type: ['dateColumn'], cellClass: 'ExcelDate' },

    { field: 'DrillingCost', headerName: 'Drilling $', valueFormatter: params => currencyFormatter(params.value, '$') },
    { field: 'StimCost', headerName: 'Stim $', valueFormatter: params => currencyFormatter(params.value, '$') },
    { field: 'PostStimCost', headerName: 'PostStim $', valueFormatter: params => currencyFormatter(params.value, '$') },
    { field: 'TankBatteryInitialBuildAndExpansionCost', headerName: 'TB Init/Exp $', valueFormatter: params => currencyFormatter(params.value, '$') },
    { field: 'TankBatteryOtherCost', headerName: 'TB Other $', valueFormatter: params => currencyFormatter(params.value, '$') },
    { field: 'FlowlineCost', headerName: 'Flowline $', valueFormatter: params => currencyFormatter(params.value, '$') },
    { field: 'PipelineCost', headerName: 'Pipeline $', valueFormatter: params => currencyFormatter(params.value, '$') },
    { field: 'WellPadFacilityCost', headerName: 'Well Pad $', valueFormatter: params => currencyFormatter(params.value, '$') },
    { field: 'WellHookupCost', headerName: 'Well Hookup $', valueFormatter: params => currencyFormatter(params.value, '$') },
    { field: 'PadConstructionCost', headerName: 'Pad Construction $', valueFormatter: params => currencyFormatter(params.value, '$') },

    { field: 'DrillingNetCost', headerName: 'Drilling Net $', valueFormatter: params => currencyFormatter(params.value, '$') },
    { field: 'StimNetCost', headerName: 'Stim Net $', valueFormatter: params => currencyFormatter(params.value, '$') },
    { field: 'PostStimNetCost', headerName: 'PostStim Net $', valueFormatter: params => currencyFormatter(params.value, '$') },
    { field: 'TankBatteryInitialBuildAndExpansionNetCost', headerName: 'TB Init/Exp Net $', valueFormatter: params => currencyFormatter(params.value, '$') },
    { field: 'TankBatteryOtherNetCost', headerName: 'TB Other Net $', valueFormatter: params => currencyFormatter(params.value, '$') },
    { field: 'FlowlineNetCost', headerName: 'Flowline Net $', valueFormatter: params => currencyFormatter(params.value, '$') },
    { field: 'PipelineNetCost', headerName: 'Pipeline Net $', valueFormatter: params => currencyFormatter(params.value, '$') },
    { field: 'WellPadFacilityNetCost', headerName: 'Well Pad Net $', valueFormatter: params => currencyFormatter(params.value, '$') },
    { field: 'WellHookupNetCost', headerName: 'Well Hookup Net $', valueFormatter: params => currencyFormatter(params.value, '$') },
    { field: 'PadConstructionNetCost', headerName: 'Pad Construction Net $', valueFormatter: params => currencyFormatter(params.value, '$') },

    {
      cellRenderer: PxdAgGridForecastValidationCellRendererComponent,
      field: 'IsValidationPassed',
      headerName: 'Pass QC Check',
      valueGetter: params => params.data.IsValidationPassed ? "Yes" : "No",
      valueFormatter: params => params.value,
      filter: 'agSetColumnFilter',
      filterParams: {
        values: ["Yes", "No"]
      }
    },
    { field: 'Updated', type: ['dateColumn'], valueFormatter: dateFormatter, cellClass: 'ExcelDate', }
  ],
  getRowClass: function (params) {
    if (params.data.IsValidationPassed === false) {
      return 'ag-row-validation-failed';
    }
  },
  excelStyles: PxdAgGridExcelStyles
};

function currencyFormatter(currency, sign) {
  var sansDec = (currency || 0).toFixed(0);
  var formatted = sansDec.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  return sign + `${formatted}`;
}

function dateFormatter(params) {
  return moment(params.value).format('MM/DD/YYYY hh:mm a');
}
